<div class="d-flex justify-content-center">
  <div class="spinner-border" role="status" style="width:300px; height:300px;">
    <span class="sr-only">Loading...</span>
  </div>
</div>